module.exports = __webpack_public_path__ + "static/media/sand-loading-bubble-bg.73825e85.png";